module.exports = __webpack_public_path__ + "static/media/tiles_street_1day.e27c0465.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/tiles_street_1day.png
// module id = 298
// module chunks = 0